@if (!bulkUpload) {
  <form
    class="flex column"
    id="bulk-upload-form"
    [formGroup]="form"
    (submit)="submit()"
  >
    <div
      class="flex"
      id="bulk-upload-form-init"
    >
      <payee-form-field>
        <span payee-label>Hitelező</span>
        <div class="field-with-clear">
          <payee-autocomplete
            formControlName="client"
            [displayWith]="clientDisplayWith"
            [options]="clientOptions"
            (searchChange)="searchClients.next($event)"
          ></payee-autocomplete>
          @if (client.value) {
            <button
              payee-icon-button
              color="white"
              type="button"
              (click)="client.setValue(null)"
            >
              <payee-icon name="trash-red"></payee-icon>
            </button>
          }
        </div>
        @if (client.invalid && client.dirty) {
          <ng-container payee-error>
            @if (client.hasError("unknown")) {
              <span>
                {{ client.errors?.unknown }}
              </span>
            }
            @if (client.hasError("required")) {
              <span>Mező kitöltése kötelező!</span>
            }
          </ng-container>
        }
      </payee-form-field>
      <payee-form-field>
        <span payee-label>Partner</span>
        <div class="field-with-clear">
          <payee-autocomplete
            formControlName="partner"
            [displayWith]="partnerDisplayWith"
            [options]="partnerOptions"
            (searchChange)="searchPartners.next($event)"
          ></payee-autocomplete>
          @if (partner.value) {
            <button
              payee-icon-button
              color="white"
              type="button"
              (click)="partner.setValue(null)"
            >
              <payee-icon name="trash-red"></payee-icon>
            </button>
          }
        </div>
        @if (partner.invalid && partner.dirty) {
          @if (partner.hasError("unknown")) {
            <span>
              {{ partner.errors?.unknown }}
            </span>
          }
        }
      </payee-form-field>
      <payee-form-field>
        <span payee-label>Létrehozási stratégia</span>
        <div class="field-with-clear">
          <payee-dropdown
            formControlName="creation_strategy"
            [options]="creationStrategyOptions"
            [displayWith]="creationStrategyDisplayWith"
          ></payee-dropdown>
          @if (creation_strategy.value) {
            <button
              payee-icon-button
              color="white"
              type="button"
              (click)="creation_strategy.setValue(null)"
            >
              <payee-icon name="trash-red"></payee-icon>
            </button>
          }
        </div>
        @if (creation_strategy.invalid && creation_strategy.dirty) {
          <ng-container payee-error>
            @if (creation_strategy.hasError("required")) {
              <span>Mező kitöltése kötelező!</span>
            }
            @if (creation_strategy.hasError("unknown")) {
              <span>
                {{ creation_strategy.errors?.unknown }}
              </span>
            }
          </ng-container>
        }
      </payee-form-field>
      <payee-form-field>
        <span payee-label>Tömeges feltöltés neve</span>
        <input
          payee-input
          formControlName="name"
        />
        @if (name.invalid && name.dirty) {
          <ng-container payee-error>
            @if (name.hasError("required")) {
              <span>Mező kitöltése kötelező!</span>
            }
            @if (name.hasError("unknown")) {
              <span>
                {{ name.errors?.unknown }}
              </span>
            }
          </ng-container>
        }
      </payee-form-field>
      <payee-form-field>
        <span payee-label>Adós típusa</span>
        <div class="field-with-clear">
          <payee-autocomplete
            formControlName="debtor_party_type"
            [displayWith]="partyTypeDisplayWith"
            [options]="partyTypeOptions"
          ></payee-autocomplete>
          @if (debtor_party_type.value) {
            <button
              payee-icon-button
              color="white"
              type="button"
              (click)="debtor_party_type.setValue(null)"
            >
              <payee-icon name="trash-red"></payee-icon>
            </button>
          }
        </div>
        @if (debtor_party_type.invalid && debtor_party_type.dirty) {
          <ng-container payee-error>
            @if (debtor_party_type.hasError("unknown")) {
              <span>
                {{ debtor_party_type.errors?.unknown }}
              </span>
            }
          </ng-container>
        }
      </payee-form-field>
      <payee-form-field>
        <span payee-label>Követelés típusa</span>
        <div class="field-with-clear">
          <payee-autocomplete
            formControlName="claim_type"
            [displayWith]="claimTypeDisplayWith"
            [options]="claimTypeOptions"
          ></payee-autocomplete>
          @if (claim_type.value) {
            <button
              payee-icon-button
              color="white"
              type="button"
              (click)="claim_type.setValue(null)"
            >
              <payee-icon name="trash-red"></payee-icon>
            </button>
          }
        </div>
        @if (claim_type.invalid && claim_type.dirty) {
          <ng-container payee-error>
            @if (claim_type.hasError("unknown")) {
              <span>
                {{ claim_type.errors?.unknown }}
              </span>
            }
          </ng-container>
        }
      </payee-form-field>
      <payee-form-field>
        <span payee-label>Jogviszony</span>
        <div class="field-with-clear">
          <payee-autocomplete
            formControlName="legal_relationship"
            [displayWith]="legalRelationshipDisplayWith"
            [options]="legalRelationshipOptions"
          ></payee-autocomplete>
          @if (legal_relationship.value) {
            <button
              payee-icon-button
              color="white"
              type="button"
              (click)="legal_relationship.setValue(null)"
            >
              <payee-icon name="trash-red"></payee-icon>
            </button>
          }
        </div>
        @if (legal_relationship.invalid && legal_relationship.dirty) {
          <ng-container payee-error>
            @if (legal_relationship.hasError("unknown")) {
              <span>
                {{ legal_relationship.errors?.unknown }}
              </span>
            }
          </ng-container>
        }
      </payee-form-field>
      <payee-form-field>
        <span payee-label>Globális termék</span>
        <div class="field-with-clear">
          <payee-dropdown
            formControlName="product_type"
            placeholder="Válassz egy terméket"
            [options]="productTypeOptions"
            [displayWith]="productTypeDisplayWith"
          ></payee-dropdown>
          @if (product_type.value) {
            <button
              payee-icon-button
              color="white"
              type="button"
              (click)="product_type.setValue(null)"
            >
              <payee-icon name="trash-red"></payee-icon>
            </button>
          }
        </div>
        @if (product_type.invalid && product_type.dirty) {
          <ng-container payee-error>
            @if (product_type.hasError("unknown")) {
              <span>
                {{ product_type.errors?.unknown }}
              </span>
            }
          </ng-container>
        }
        <div class="product-type-disclaimer">
          <payee-icon
            name="info"
            class="disclaimer-icon"
          ></payee-icon>
          <span class="disclaimer-text">A globális termék felülírja az excel-ben szereplő terméket</span>
        </div>
      </payee-form-field>
      <payee-form-field>
        <span payee-label>Globális ügy típusa</span>
        <div class="field-with-clear">
          <payee-dropdown
            formControlName="case_type"
            placeholder="Válassz egy ügy típust"
            [options]="caseTypeOptions"
            [displayWith]="caseTypeDisplayWith"
          ></payee-dropdown>
          @if (case_type.value) {
            <button
              payee-icon-button
              color="white"
              type="button"
              (click)="case_type.setValue(null)"
            >
              <payee-icon name="trash-red"></payee-icon>
            </button>
          }
        </div>
        @if (case_type.invalid && case_type.dirty) {
          <ng-container payee-error>
            @if (case_type.hasError("unknown")) {
              <span>
                {{ case_type.errors?.unknown }}
              </span>
            }
          </ng-container>
        }
        <div class="product-type-disclaimer">
          <payee-icon
            name="info"
            class="disclaimer-icon"
          ></payee-icon>
          <span class="disclaimer-text">A globális ügy típus felülírja az excel-ben szereplő ügy típust</span>
        </div>
      </payee-form-field>
      <payee-form-field>
        <span payee-label>Globális kamat típusa</span>
        <div class="field-with-clear">
          <payee-dropdown
            formControlName="interest_type"
            placeholder="Válassz egy kamat típust"
            [options]="interestTypeOptions"
            [displayWith]="interestTypeDisplayWith"
          ></payee-dropdown>
          @if (interest_type.value) {
            <button
              payee-icon-button
              color="white"
              type="button"
              (click)="interest_type.setValue(null)"
            >
              <payee-icon name="trash-red"></payee-icon>
            </button>
          }
        </div>
        @if (interest_type.invalid && interest_type.dirty) {
          <ng-container payee-error>
            @if (interest_type.hasError("unknown")) {
              <span>
                {{ interest_type.errors?.unknown }}
              </span>
            }
          </ng-container>
        }
      </payee-form-field>
      <payee-form-field>
        <span payee-label>Tömeges ügy excel/csv</span>
        <div class="flex column dropzone-container">
          @if (!file.value) {
            <payee-dropzone
              title="Tömeges ügy excel/csv"
              description=""
              accept=".csv,.xlsx"
              [multiple]="false"
              (dropped)="fileDropped($event)"
            ></payee-dropzone>
          } @else {
            <div class="flex vcenter selected-file">
              <h2>{{ file.value.name }}</h2>
              <button
                payee-icon-button
                color="white"
                type="button"
                (click)="deleteFile()"
              >
                <payee-icon name="trash-red"></payee-icon>
              </button>
            </div>
          }
          @if (file.invalid && file.dirty) {
            <div color="alert-red">
              @if (file.hasError("unknown")) {
                <div>
                  {{ file.errors?.unknown }}
                </div>
              }
              @if (file.hasError("required")) {
                <span>Mező kitöltése kötelező!</span>
              }
            </div>
          }
        </div>
      </payee-form-field>
      <payee-form-field>
        <span payee-label>Követelés bizonyítéka</span>
        <div class="flex column dropzone-container">
          @if (!claim_file.value) {
            <payee-dropzone
              title="Követelés bizonyítéka"
              description=""
              [multiple]="false"
              (dropped)="claimFileDropped($event)"
            ></payee-dropzone>
          } @else {
            <div class="flex vcenter selected-file">
              <h2>{{ claim_file.value.name }}</h2>
              <button
                payee-icon-button
                color="white"
                type="button"
                (click)="deleteClaimFile()"
              >
                <payee-icon name="trash-red"></payee-icon>
              </button>
            </div>
          }
          @if (claim_file.invalid && claim_file.dirty) {
            <div color="alert-red">
              @if (claim_file.hasError("unknown")) {
                <div>
                  {{ claim_file.errors?.unknown }}
                </div>
              }
              @if (claim_file.hasError("required")) {
                <span>Mező kitöltése kötelező!</span>
              }
            </div>
          }
        </div>
      </payee-form-field>
      @if (loading()) {
        <mat-progress-spinner
          mode="indeterminate"
          diameter="24"
          class="form-loading-spinner"
        ></mat-progress-spinner>
      }
    </div>
    @if (file.value) {
      <div class="flex vcenter column-section-header">
        <button
          payee-icon-button
          color="white"
          type="button"
          (click)="toggleCollapse()"
        >
          <payee-icon [name]="collapsed() ? 'expand' : 'collapse'"></payee-icon>
        </button>
        <h1>Oszlop társítás</h1>
        @if (file.value) {
          <button
            payee-button
            width="short"
            [disabled]="loading()"
          >
            Feltöltés
          </button>
        }
      </div>
    }
    @if (payee_case_references.invalid && payee_case_references.dirty) {
      <div class="payee-references-error">
        @if (payee_case_references.hasError("required")) {
          <span>Legalább egy ügyazonosítót ki kell választani!</span>
        }
      </div>
    }
    @if (claim_references.invalid && claim_references.dirty) {
      <div class="claim-references-error">
        @if (claim_references.hasError("required")) {
          <span>Legalább egy követelés azonosítót ki kell választani!</span>
        }
      </div>
    }
    @if (file.value && !collapsed()) {
      @if ((requiredColumns | keyvalue).length > 0) {
        <h1>Kötelező oszlopok</h1>
      }
      @for (column of requiredColumns | keyvalue; track column.key) {
        <ng-container
          [ngTemplateOutlet]="columnForm"
          [ngTemplateOutletContext]="{
            control: column_associations.controls[column.key],
            payeeCaseRefControl: payee_case_references.controls[column.key],
            claimRefControl: claim_references.controls[column.key],
            label: column.value,
          }"
        ></ng-container>
      }
      @if ((optionalColumns | keyvalue).length > 0) {
        <h1>Opcionális oszlopok</h1>
      }
      @for (column of optionalColumns | keyvalue; track column.key) {
        <ng-container
          [ngTemplateOutlet]="columnForm"
          [ngTemplateOutletContext]="{
            control: column_associations.controls[column.key],
            payeeCaseRefControl: payee_case_references.controls[column.key],
            claimRefControl: claim_references.controls[column.key],
            label: column.value,
          }"
        ></ng-container>
      }
    }
    @if (collapsed() && file.value) {
      <div
        class="bulk-upload-summary flex vcenter"
        role="button"
        tabindex="0"
        (click)="expandForm()"
        (keydown.enter)="expandForm()"
        (keydown.space)="expandForm(); $event.preventDefault()"
      >
        <payee-icon name="checkmark-darker-green-circle"></payee-icon>
        <div class="summary-data flex column grow1">
          <div class="columns-info">
            <strong>Oszlop társítások:</strong>
            {{ filledRequiredAssociationsCount }}/{{ (requiredColumns | keyvalue).length }} kötelező,
            {{ filledOptionalAssociationsCount }}/{{ (optionalColumns | keyvalue).length }}
            opcionális
          </div>
        </div>
        <payee-icon name="chevron-down"></payee-icon>
      </div>
    }
  </form>
}

<!-- Validating Data Section -->
@if (validatingData && !bulkUpload) {
  <div class="batch-status-section">
    <div class="batch-status-header">
      <h2>Adatok validálása</h2>
    </div>
    <div class="batch-progress-container">
      <div class="batch-loading">
        <div class="loading-text">Excel fájl feldolgozása és adatok validálása...</div>
      </div>
    </div>
  </div>
}

<!-- Batch Status Section -->
@if (bulkUpload) {
  <div class="batch-status-section">
    <div class="batch-status-header">
      <h2>Tömeges feltöltés folyamatban</h2>
      <div class="batch-info">
        <div class="batch-id">Bulk Upload ID: {{ bulkUpload.id }}</div>
        <div class="batch-state-container">
          <span class="batch-state-label">Állapot:</span>
          <span
            class="batch-state-value"
            [ngClass]="'state-' + bulkUpload.state"
          >
            {{ getStateLabel(bulkUpload.state) }}
          </span>
        </div>
      </div>
    </div>
    <div class="batch-progress-container">
      <!-- Loading state when batchStatus is not yet available -->
      @if (!batchStatus) {
        <div class="batch-loading">
          <div class="loading-text">Batch állapot betöltése...</div>
        </div>
      }
      <!-- Status display when batchStatus is available -->
      @if (batchStatus) {
        <div>
          <div class="progress-stats">
            <div class="stat-item">
              <div class="stat-label">Összes feladat</div>
              <div class="stat-value">{{ batchStatus.total_jobs }}</div>
            </div>
            <div class="stat-item">
              <div class="stat-label">Függőben</div>
              <div class="stat-value pending">{{ batchStatus.pending_jobs }}</div>
            </div>
            <div class="stat-item">
              <div class="stat-label">Sikertelen</div>
              <div class="stat-value failed">{{ batchStatus.failed_jobs }}</div>
            </div>
            @if (batchStatus.wait) {
              <div class="stat-item">
                <div class="stat-label">Becsült várakozási idő</div>
                <div class="stat-value wait">{{ batchStatus.wait }} perc</div>
              </div>
            }
          </div>
          <div class="batch-actions">
            <button
              payee-button
              color="alert-red"
              (click)="retryFailedJobs()"
            >
              Hibás feladatok újrapróbálása
            </button>
            <button
              payee-button
              color="primary"
              class="view-cases-btn"
              (click)="navigateToCases()"
            >
              Ügyek megtekintése
            </button>
          </div>
        </div>
      }
    </div>
    <!-- Global actions that are always visible when bulk upload is active -->
    <div class="global-actions">
      <button
        payee-button
        color="secondary"
        class="new-upload-btn"
        (click)="startNewBulkUpload()"
      >
        Új tömeges feltöltés
      </button>
    </div>
  </div>
}

@if (errorMessages.length > 0) {
  <div class="error-messages-section">
    <div class="error-messages-header">
      <h2>Hibaüzenetek ({{ errorMessages.length }})</h2>
      <button
        payee-icon-button
        color="white"
        type="button"
        (click)="clearErrorMessages()"
      >
        <payee-icon name="trash-red"></payee-icon>
      </button>
    </div>
    <div class="error-messages-list">
      @for (error of paginatedErrorMessages; track error) {
        <div class="error-message">
          {{ error }}
        </div>
      }
    </div>
    @if (errorMessages.length > 0) {
      <mat-paginator
        showFirstLastButtons
        [length]="errorMessages.length"
        [pageSize]="pageSize"
        [pageIndex]="pageIndex"
        [pageSizeOptions]="[5, 10, 25, 100]"
        (page)="onPageChange($event)"
      ></mat-paginator>
    }
  </div>
}

<ng-template
  #columnForm
  let-control="control"
  let-payeeCaseRefControl="payeeCaseRefControl"
  let-claimRefControl="claimRefControl"
  let-label="label"
>
  @if (control) {
    <div class="flex vcenter column-association">
      <div
        title="{{ label }}"
        class="column-name"
      >
        {{ label }}
      </div>
      <payee-form-field>
        <payee-autocomplete
          [formControl]="control"
          [options]="columnOptions"
          [displayWith]="columnDisplayWith"
        ></payee-autocomplete>
        @if (control.invalid && control.dirty) {
          <ng-container payee-error>
            @if (control.hasError("required")) {
              <span>Mező kitöltése kötelező</span>
            }
          </ng-container>
        }
      </payee-form-field>
      <div
        class="example-chip"
        [ngClass]="{ placeholder: !getExampleValue(control.value) }"
      >
        {{ getExampleValue(control.value) || "—" }}
      </div>
      <button
        payee-icon-button
        color="white"
        type="button"
        (click)="control!.setValue(null)"
      >
        <payee-icon name="trash-red"></payee-icon>
      </button>
      <div class="checkbox-column">
        <app-custom-checkbox [formControl]="payeeCaseRefControl">Ügyazonosító</app-custom-checkbox>
      </div>
      <div class="checkbox-column">
        <app-custom-checkbox [formControl]="claimRefControl">Követelés azonosító</app-custom-checkbox>
      </div>
    </div>
  }
</ng-template>
